export default __webpack_public_path__ + "9b3f222968cb2f20756d81eb9690d5ce.svg";